import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import Api from "../Api.js";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ClipLoader} from "react-spinners";
import ReactPaginate from "react-paginate";
import qs from "query-string";
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import SearchBar from "../components/SearchBar.js";

function Users() {
    const location = useLocation()
    const navigate = useNavigate()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const [client, setClient] = useState({})
    const [loading, setLoading] = useState(true)
    const [current, setCurrent] = useState(0)
    const [search, setSearch] = useState('')
    const getClient = async (offset,search) => {
        try {
            setLoading(true)
            const {data} = await Api.clientGet(offset || '',search || '');
            setClient(data)
            setLoading(false)
        } catch (e) {

        }
    }
    useEffect(() => {
        (async () => {
            await getClient(query.offset || '', query.search || '')
        })()
    }, [location.search])

    const handleSearch = async (value) => {
        query.search = value
        const stringify = qs.stringify(query, {addQueryPrefix: true, encode: false});
        navigate(`?${stringify}`, {replace: true});
    }

    const handlePageChange = async (pageNumber) => {
        const offset = pageNumber === 0 ? '' : (pageNumber -1 ) * 10;
        setCurrent(pageNumber)
        query.offset = offset
        const stringify = qs.stringify(query, {addQueryPrefix: true, encode: false});
        navigate(`?${stringify}`, {replace: true});
    };

    const handleDelete = async (e) => {
        e.stopPropagation();
        const id = e.currentTarget.getAttribute('data-id');
        if (window.confirm('Համոզված եք, որ ցանկանում եք ջնջել այս օգտատիրոջը?')) {
            try {
                e.stopPropagation();
                await Api.clientDelete(id);
                await getClient(query.offset || '', query.search || '');
            } catch (e) {
                console.error(e);
            }
        }
    }
    return (
        <Wrapper>
            <div className='users'>
                <div style={{marginTop:20}}>
                    <SearchBar onChange={(value) => handleSearch(value)} value={query.search || ''}/>
                </div>


                <div className='data-user'>
                    <span>Անուն ազգանուն</span>
                    <span>Հեռախոս</span>
                    <span>էլեկտրոնային հասցե</span>
                    <span>Ջնջել</span>
                </div>
                {client?.results?.map((c, index) => (
                    <p  key={index}>
                        <div className='user-task'>
                            <span ><Link to={`/main_employee/users/${c.id}`}>{c?.user?.first_name} {c?.user?.last_name}</Link></span>
                            <span ><Link to={`/main_employee/users/${c.id}`}>{c?.phone}</Link></span>
                            <span ><Link to={`/main_employee/users/${c.id}`}>{c?.user?.email}</Link></span>
                            <span ><i data-id={c.id} className="fas fa-trash-alt" onClick={handleDelete}/></span>
                        </div>
                    </p>
                ))}
                {loading && <ClipLoader type="Oval" color="#101C2A" size={30}/>}


                {client?.count > 10 && (

                    <div className="d-flex justify-content-center">
                        <CustomPagination
                            currentPage={+query.offset?+query.offset/ 10 + 1 : 1}
                            totalItems={client?.count}
                            itemsPerPage={10}
                            totalPages={Math.ceil(client?.count / 10) || 0}
                            onPageChange={(newPage) => handlePageChange(newPage)}
                        />
                    </div>
                )}
            </div>
        </Wrapper>
    );
}

export default Users;